import defaultReplication from '@/rxdb/defaultReplication';
import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';

export const companies = {
    schema: {
        title: 'company schema',
        version: 0,
        description: 'describes a company',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: {
                type: 'string',
                final: true,
                maxLength: 40,
            },
            name: {
                type: ['string', 'null'],
            },
            address1: {
                type: ['string', 'null'],
            },
            address2: {
                type: ['string', 'null'],
            },
            address3: {
                type: ['string', 'null'],
            },
            city: {
                type: ['string', 'null'],
            },
            postalCode: {
                type: ['string', 'null'],
            },
            phone: {
                type: ['string', 'null'],
            },
            siret: {
                type: ['string', 'null'],
            },
            email: {
                type: ['string', 'null'],
            },
            logoUrl: {
                type: ['string', 'null'],
            },
            createdBy: {
                type: ['string', 'null'],
            },
            updatedAt: {
                type: ['string', 'null'],
            },
            deletedAt: {
                type: ['string', 'null'],
            },
            deletedBy: {
                type: ['string', 'null'],
            },
            createdAt: {
                type: ['string', 'null'],
            },
            updatedBy: {
                type: ['string', 'null'],
            },
            projectId: {
                type: ['string', 'null'],
            },
            rootVersion: {
                type: ['string', 'null'],
            },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {},
};
